/**
 * LinkedIn-style bouncing dots shown while the other person is typing.
 */
import React from "react";
import { Box } from "@mui/material";

/**
 * True when HTML from the composer contains visible text.
 *
 * @param {string} html Composer HTML.
 * @returns {boolean}
 */
export const htmlHasText = (html) =>
  String(html || "")
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim().length > 0;

/**
 * Three bouncing dots, indented to line up with incoming chat bubbles
 * (40px avatar column + 12px gap).
 *
 * @returns {JSX.Element}
 */
const ChatTypingDots = () => (
  <Box className="flex w-3/4 mt-1 items-end" aria-label="typing">
    <Box sx={{ width: 40, minWidth: 40, height: 40, flexShrink: 0 }} />
    <Box sx={{ ml: 1.5 }}>
      <Box className="v-typing-dots">
        <span />
        <span />
        <span />
      </Box>
    </Box>
  </Box>
);

export default ChatTypingDots;
